import { QRCode } from "antd";

/**
 * Renders enrollment data as a high-contrast QR independent of the application theme.
 * Explicit black modules on a white background remain scannable in dark mode, while
 * SVG rendering avoids depending on canvas drawing for this security-critical control.
 *
 * @param {Object} props Enrollment QR properties.
 * @param {string} props.value Enrollment URI provided by the MFA API.
 * @param {string} props.label Translated accessible description of the QR code.
 * @returns {React.ReactElement} QR code with a white quiet zone and themed outer frame.
 */
export default function MfaEnrollmentQr({ value, label }) {
  return (
    <div className="auth-shell__qr">
      <QRCode aria-label={label} value={value} type="svg" color="#000000" bgColor="#ffffff" size={220} marginSize={8} />
    </div>
  );
}
